import React, { useMemo, useState, useEffect } from "react";
import Icon from "components/Elements/Icon/Icon.tsx";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import Image from "components/Elements/Image/Image.tsx";
import Button from "components/Elements/Button/Button";
import BlackFridayPromoElem from "components/Reusable/BlackFriday/BlackFridayPromoElem";
import queryString from "query-string";
import useMediaQueries from "hooks/useMediaQueries";
import HeaderFeaturesList from "./HeaderFeaturesList";
import EnterpriseNotiComponent from "./EnterpriseNotiComponent";
import { useContent } from "contexts/contentContext/contentContext.js";
import { LinkToNewTab } from "components/Elements/Link/Link";
import { plansList } from "../Utils/Lists";
import { useLocation } from "react-router-dom";

const FeaturesPage = ({
  isYearly,
  clickedCard,
  subscriptionType,
  openCancelSubscriptionModal,
  prices,
  coupons,
}) => {
  const { getTextByKey, getBlackFridayTime, getCouponCode } = useContent();
  const { mobileCondition } = useMediaQueries();
  const [jumbomailList, setJumbomailList] = useState([]);
  const [jumboPayList, setJumboPayList] = useState([]);
  const [jumboFormsList, setJumboFormsList] = useState([]);
  const [brandingList, setBrandingList] = useState([]);
  const [securityList, setSecurityList] = useState([]);
  const [jumboPickerList, setJumboPickerList] = useState([]);

  const location = useLocation();
  const objectFeaturesList = {
    JUMBOmail: {
      title: "JUMBOmail",
      state: jumbomailList,
      setState: setJumbomailList,
    },
    Security: {
      title: "security",
      state: securityList,
      setState: setSecurityList,
    },
    Branding: {
      title: "branding",
      state: brandingList,
      setState: setBrandingList,
    },
    JUMBOforms: {
      title: "JUMBOforms",
      state: jumboFormsList,
      setState: setJumboFormsList,
    },
    JUMBOpay: {
      title: "JUMBOpay",
      state: jumboPayList,
      setState: setJumboPayList,
    },
    JUMBOpicker: {
      title: "JUMBOpicker",
      state: jumboPickerList,
      setState: setJumboPickerList,
    },
  };

  //Get the features from DB
  const getAllFeaturesFromDB = async () => {
    //if the device is not mobile
    //if (window.innerWidth > 600) {
    //GetAllPlansFeatures
    const response = await apiRequest("Packages", "GetAllPlansFeatures");
    if (response.status === "success") {
      if (response.data) {
        Object.entries(response.data).forEach(([key, listObject]) => {
          objectFeaturesList[key].setState(listObject);
        });
      }
    }
    //}
  };

  useEffect(() => {
    // scrolling depends on URL #
    const param = queryString.parse(location.search);
    // check what params contain and scroll into it value
    const scrollTo = param["scroll"];

    if (scrollTo) {
      window.onload = () => {
        const element = document.getElementById(scrollTo);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      };
    }
  }, []);

  const rowPlanValue = (value) => {
    return value === "v" ? (
      <Image name="plans/v-icon" ext="svg" title="" alt="" className="v-icon" />
    ) : value === "x" ? (
      <Image name="plans/x-icon" ext="svg" title="" alt="" className="x-icon" />
    ) : (
      <span>{getTextByKey(value)}</span>
    );
  };

  const rowFeraturesList = (item, index, isButtons) => {
    return (
      <div className={`feature-row ${isButtons ? "is-buttons" : ""}`}>
        <div className="feature-title col">
          <span className="item-title">
            {!isButtons && getTextByKey(item.title)}
          </span>
          {item.description && !isButtons && (
            <Tooltip
              mobileClickability
              id={`${item.title}-${index}`}
              tooltipTextKey={item.description}
              end
              //hardPositioned={true}
            >
              <div className="info-tooltip">
                <Icon name="i" white />
              </div>
            </Tooltip>
          )}
        </div>
        {mobileCondition ? (
          clickedCard === "free" ? (
            <div className="free col">
              {isButtons
                ? renderButtons(plansList[0])
                : rowPlanValue(item.free)}
            </div>
          ) : clickedCard === "pro" ? (
            <div className="pro col">
              {isButtons ? renderButtons(plansList[1]) : rowPlanValue(item.pro)}
            </div>
          ) : clickedCard === "business" ? (
            <div className="business col">
              {isButtons
                ? renderButtons(plansList[2])
                : rowPlanValue(item.business)}
            </div>
          ) : (
            <div className="premium col">
              {isButtons
                ? renderButtons(plansList[3])
                : rowPlanValue(item.premium)}
            </div>
          )
        ) : (
          <>
            <div className="free col">
              {isButtons
                ? renderButtons(plansList[0])
                : rowPlanValue(item.free)}
            </div>
            <div className="pro col">
              {isButtons ? renderButtons(plansList[1]) : rowPlanValue(item.pro)}
            </div>
            <div className="business col">
              {isButtons
                ? renderButtons(plansList[2])
                : rowPlanValue(item.business)}
            </div>
            <div className="premium col">
              {isButtons
                ? renderButtons(plansList[3])
                : rowPlanValue(item.premium)}
            </div>
          </>
        )}
      </div>
    );
  };

  const featuresTable = (list, type, i) => {
    if (!list || list.length === 0) {
      return null;
    }
    return type !== "Buttons" ? (
      <div className="features-table" key={type}>
        <HeaderFeaturesList
          type={type}
          clickedCard={clickedCard}
          isYearly={isYearly}
          prices={prices}
          alwaysSticky={i === 0}
          coupons={coupons}
        />
        {list.map((item, index) => (
          <div key={index} className="feature-row-container">
            {rowFeraturesList(item, index, false)}
          </div>
        ))}
      </div>
    ) : (
      <div className="features-table" key={type}>
        {list.map((plan, index) => (
          <div key={index} className="feature-row-container">
            {rowFeraturesList(plan, index, true)}
          </div>
        ))}
      </div>
    );
  };

  useMemo(() => {
    getAllFeaturesFromDB();
  }, []);

  const renderObjectsList = () => {
    //return map of objectFeaturesList and render the featuresTable
    return Object.entries(objectFeaturesList).map(([key, listObject], i) => {
      return featuresTable(listObject.state, key, i);
    });
  };

  //openCancelSubscriptionModal

  const renderButtons = (card) => {
    const isDisabled = card.title === subscriptionType ? true : false;
    return isDisabled ? (
      <div className="card-plans-button disabled-button">
        <Button className="new-button" gray>
          {getTextByKey("current-plan")}
        </Button>
      </div>
    ) : (
      <div className="card-plans-button">
        {card.title !== "free" ? (
          <LinkToNewTab
            page={`${isYearly ? card.linkYearly : card.linkMonthly}${
              getBlackFridayTime() && isYearly
                ? `\\coupon\\${getCouponCode()}`
                : ``
            }`}
          >
            {isYearly ? <BlackFridayPromoElem /> : null}
            <Button className="new-button">
              {getTextByKey("choose-plan")}
            </Button>
          </LinkToNewTab>
        ) : subscriptionType ? (
          <Button
            className="new-button"
            onClick={() => openCancelSubscriptionModal()}
          >
            {getTextByKey("cancel-subscription")}
          </Button>
        ) : (
          <LinkToNewTab page={"registration"}>
            <Button className="new-button">
              {getTextByKey("create-account")}
            </Button>
          </LinkToNewTab>
        )}
      </div>
    );
  };

  return (
    <div className="plans-features" id="plans-features-id">
      <div className="plans-features-header">
        <h2>{getTextByKey("features")}</h2>
      </div>
      <div className="plans-features-body">{renderObjectsList()}</div>
      <EnterpriseNotiComponent />
    </div>
  );
};

export default FeaturesPage;
